module.exports = __webpack_public_path__ + "img/icon-cart.fe071d01.svg";